import React, { useEffect, useState } from 'react';
import { TEXT } from 'locales/translations';
import { Paragraph, Spinner } from 'Common';
import { Slider, HoverImageLink } from 'Component';
import { CooperationStyle } from './Cooperations.style';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { breakpoints } from 'Theme';
import { getInsuranceCompaniesRequest } from 'redux/actions';
import { getInsuranceCompanies } from 'redux/query';
import { useDispatch, useSelector } from 'react-redux';

export const Cooperations = ({ id }) => {
  const dispatch = useDispatch();
  const [settings, setSettings] = useState({
    dots: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    speed: 0,
    autoplaySpeed: 0,
    variableWidth: true,
    swipe: false,
    accessibility: false,
    arrows: false
  });

  const MAX_SMALL_SET_SIZE = 7;
  const HALF_LOGO_BOX_WIDTH = '-80px';
  const NO_PADDING = '0px';

  const [activeCooperationPartnersCount, setActiveCooperationPartnersCount] = useState(0);

  useEffect(() => {
    dispatch(getInsuranceCompaniesRequest(true));
  }, [dispatch]);

  const { insuranceCompanies: activeCooperationPartners } = useSelector(getInsuranceCompanies);

  useEffect(() => {
    setActiveCooperationPartnersCount(activeCooperationPartners.length);
  }, [activeCooperationPartners]);

  useEffect(() => {
    const isSmallSetOfIcons = activeCooperationPartnersCount <= MAX_SMALL_SET_SIZE;
    const isEvenSetOfIcons = activeCooperationPartnersCount % 2 === 0;

    const defaultSettings = {
      dots: false,
      infinite: !isSmallSetOfIcons,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: !isSmallSetOfIcons,
      speed: isSmallSetOfIcons ? 0 : 1000,
      autoplaySpeed: isSmallSetOfIcons ? 0 : 5000,
      variableWidth: true,
      centerMode: true,
      initialSlide: isEvenSetOfIcons ? activeCooperationPartnersCount / 2 : Math.floor(activeCooperationPartnersCount / 2),
      centerPadding: isEvenSetOfIcons ? HALF_LOGO_BOX_WIDTH : NO_PADDING,
      swipe: false,
      accessibility: false,
      arrows: !isSmallSetOfIcons
    };

    const defaultTabletAndMobileSettings = {
      dots: true,
      infinite: true,
      swipe: true,
      swipeToSlide: true,
      autoplay: true,
      speed: 1000,
      autoplaySpeed: 5000,
      arrows: false,
      centerMode: false,
      variableWidth: true,
      pauseOnHover: true,
      pauseOnFocus: true
    };

    const newSettings = {
      ...defaultSettings,

      responsive: [
        {
          breakpoint: parseInt(breakpoints.xl, 10),
          settings: {
            ...defaultSettings
          }
        },
        {
          breakpoint: parseInt(breakpoints.lg, 10),
          settings: {
            ...defaultSettings,
            swipe: activeCooperationPartnersCount > 5 ? true : false,
            accessibility: activeCooperationPartnersCount > 5 ? true : false
          }
        },
        {
          breakpoint: parseInt(breakpoints.md, 10),
          settings: {
            ...defaultSettings,
            ...defaultTabletAndMobileSettings
          }
        },
        {
          breakpoint: parseInt(breakpoints.sm, 10),
          settings: {
            ...defaultSettings,
            ...defaultTabletAndMobileSettings,
            initialSlide: 1
          }
        }
      ]
    };
    setSettings(newSettings);
  }, [activeCooperationPartnersCount]);

  if (!activeCooperationPartners || activeCooperationPartnersCount === 0) {
    return <Spinner />;
  }

  return (
    <CooperationStyle
      id={id}
      className="text-center"
      verticalPadding={{ sm: 40, md: 30, lg: 40 }}
      backgroundColor="lightGrey"
      type="full-width"
    >
      <Paragraph className="bold">{TEXT.cooperations.headline}</Paragraph>
      <Slider key={settings.initialSlide} settings={settings} className="pink-dots">
        {activeCooperationPartners.map((cooperation) =>
          cooperation.cooperationLogo && cooperation.cooperationLogoHover ? (
            <HoverImageLink
              key={cooperation.cooperationUrl}
              image={cooperation.cooperationLogo}
              hoverImage={cooperation.cooperationLogoHover}
              href={cooperation.cooperationUrl}
              className="logo"
            />
          ) : null
        )}
      </Slider>
    </CooperationStyle>
  );
};
